
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/aanmelden",
      function () {
        return require("private-next-pages/auth/aanmelden.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/aanmelden"])
      });
    }
  